const LocationAutocomplete = ({ value, onChange, placeholder = "Location*", isDisabled = false, className }) => {
    return (
        <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={isDisabled}
            className={`w-full rounded-xl border border-slate-200 bg-input-bg px-4 py-3 text-sm text-slate-700 outline-none focus:outline-none disabled:text-slate-400 ${className || ""}`}
        />
    );
};

export default LocationAutocomplete;
